import { render } from "./ThePointsbar.vue?vue&type=template&id=47a93b66&scoped=true"
import script from "./ThePointsbar.vue?vue&type=script&lang=js"
export * from "./ThePointsbar.vue?vue&type=script&lang=js"

import "./ThePointsbar.vue?vue&type=style&index=0&id=47a93b66&scoped=true&lang=scss"

import exportComponent from "/Users/macmeow/Documents/GitHub/feedback-page-partnership/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47a93b66"]])

export default __exports__